import { useState } from "react";
import axios from "axios";
import { Send, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      setDone(true);
      setEmail("");
    } catch (err) {
      setError("Please enter a valid email address.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div data-testid="newsletter-done" className="flex items-center gap-3 text-white/80">
        <Check size={18} /> <span className="font-light">You're on the list. Thank you for standing with us.</span>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="flex flex-col sm:flex-row gap-3 max-w-md">
      <input
        type="email"
        required
        data-testid="newsletter-email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email address"
        className="flex-1 bg-transparent border border-white/20 focus:border-white outline-none px-4 py-3 text-white placeholder:text-white/35"
      />
      <button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit"
        className="group inline-flex items-center justify-center gap-2 overline px-5 py-3 bg-white text-black hover:bg-white/85 transition-colors disabled:opacity-60"
      >
        {loading ? "Joining…" : "Join"} <Send size={14} />
      </button>
      {error && <span className="text-xs text-white/70 self-center">{error}</span>}
    </form>
  );
}
